import { render, staticRenderFns } from "./contactLog.vue?vue&type=template&id=1d63880c&scoped=true"
import script from "./contactLog.vue?vue&type=script&lang=js"
export * from "./contactLog.vue?vue&type=script&lang=js"
import style0 from "./contactLog.vue?vue&type=style&index=0&id=1d63880c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63880c",
  null
  
)

export default component.exports